export const LOGIN_BUTTON_TEST_ID = {
  button: 'login-test-id',
  logout: 'logout-test-id',
  account: 'account-test-id'
};

export const LOGIN_BUTTON = {
  trigger: 'button-trigger-id'
};
